import { observer } from "mobx-react"
import { Tag, Typography } from "antd"

import { balancesStore } from "@src/app/balanceStore"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { PAYMENTS_PRICING_TYPES_OPTIONS } from "@src/pages/transactionsPayments/constants"
import {
  Payment,
  PaymentAmlLevelEnum,
  PaymentPricingTypeEnum,
  TopupPaymentResponseStatusEnum,
} from "@src/shared/api/generated"
import { TableExpandable } from "@src/shared/componemts/TableExpandable"
import { WithCopy } from "@src/shared/componemts/WithCopy"
import { dateTimeFormat } from "@src/shared/date"
import { getExplorerUrl } from "@src/shared/getExplorerUrl"

export const PaymentsTableExpandable = observer(
  ({ isLoading, payment }: { isLoading: boolean; payment: Payment }) => {
    const {
      aml_level,
      amount,
      detected_at,
      id,
      network,
      pricing_type,
      status,
      symbol,
      tx_id,
    } = payment

    const { currencies } = balancesStore

    const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
      network,
      symbol,
    })

    const operationWithUrl = getExplorerUrl([payment], currencies)[0]

    const cMap = {
      [PaymentAmlLevelEnum.High]: "error",
      [PaymentAmlLevelEnum.Low]: "green",
      [PaymentAmlLevelEnum.Medium]: "warning",
    }

    const cMapStatus = {
      [TopupPaymentResponseStatusEnum.Confirmed]: "green",
      [TopupPaymentResponseStatusEnum.Failed]: "error",
      [TopupPaymentResponseStatusEnum.Pending]: "geekblue",
    }

    const pricingTypeItem = PAYMENTS_PRICING_TYPES_OPTIONS.find(
      (i) => i.value === pricing_type,
    )

    return (
      <TableExpandable
        isLoading={isLoading}
        list={[
          ["ID", <WithCopy content={id} />],
          ["Charge ID", <WithCopy content={payment.charge_id} />],
          ["Address", <WithCopy content={payment.address} />],
          ...([
            payment.refund_id
              ? [
                  "Refund ID",
                  <IdItem
                    id={payment.refund_id}
                    p={payment.refund_id.length}
                  />,
                ]
              : [],
          ] as any),
          [
            "Tx ID",
            <WithCopy
              content={tx_id}
              view={
                <Typography.Link
                  href={operationWithUrl.tx_explorer_url + tx_id}
                  target="_blank"
                >
                  {tx_id}
                </Typography.Link>
              }
            />,
          ],
          [
            "Amount",
            <Typography style={{ fontWeight: 600 }}>{amount}</Typography>,
          ],
          ["Network", `${network}`],
          ["Symbol", `${currency?.symbol_alias ?? symbol}`],
          ["Status", <Tag color={cMapStatus[status]}>{status}</Tag>],
          [
            "Pricing type",
            <Typography.Text>
              {pricingTypeItem?.label ?? pricing_type}
            </Typography.Text>,
          ],
          [
            "AML Level",
            <Tag color={cMap[aml_level ?? "low"]}>{aml_level}</Tag>,
          ],
          ["Detected at", dateTimeFormat(detected_at as string)],
        ]}
      />
    )
  },
)
